import { ApiGetRequest } from '../api';

export const state = {
  data: {
    items: [],
  },
};

export const mutations = {
  changeCities(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getCities({ commit }) {
    commit('changeCities', {
      loading: true,
    });

    let result = await ApiGetRequest(`cities`);
    commit('changeCities', {
      items: !result.error ? result.data.object : [],
    });

    return !result.error ? true : false;
  },
};
